
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"cls-1",attrs:{"d":"M85 90H15V35h70zM10 10h80v15H10zm90 0A10 10 0 0090 0H10A10 10 0 000 10v25h5v65h90V35h5z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M35 45h30v10H35z"}})])
          )
        }
      }
    